import React, { type Dispatch, type SetStateAction, useMemo, useState, type ReactNode } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Breadcrumb, HeaderInner, Footer, Sidebar, InnerMenuMobile } from '@/components';

export type BreadcrumbItem = { label: string; to?: string };
export type SidebarItem = {
	label: string;
	to?: string;
	icon?: ReactNode;
	badge?: string | number;
	children?: SidebarItem[];
};

export type OutletCtx = {
	setBreadcrumb: Dispatch<SetStateAction<BreadcrumbItem[]>>;
	setSidebar: Dispatch<SetStateAction<SidebarItem[]>>;
};

export const InnerLayout = (): React.ReactElement => {
	const [breadcrumb, setBreadcrumb] = useState<BreadcrumbItem[]>([]);
	const [sidebar, setSidebar] = useState<SidebarItem[]>([]);
	const outletCtxValue = useMemo<OutletCtx>(() => ({ setBreadcrumb, setSidebar }), [setBreadcrumb, setSidebar]);

	return (
		<div className="o-layout">
			<HeaderInner sidebarItems={sidebar} />
			<InnerMenuMobile items={sidebar} />
			<Breadcrumb items={breadcrumb} />
			<div className="o-container o-layout__inner">
				<Sidebar items={sidebar} />
				<main className="o-layout__main">
					<Outlet context={outletCtxValue} />
				</main>
			</div>
			<Footer />
		</div>
	);
};
